import React, { useState } from "react";
import MainContainer from "../../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  InputBase,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ResturantForm from "./resturantForm";
import IosSwitchMain from "../../../components/iosSwitchMain";
import EventForm from "./eventForm";
import EditText from "../../../components/editText";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ExperienceForm from "./experienceForm";
import OthersForm from "./othersForm";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface EditTextProps {
  content: string;
  setContent: (value: string) => void;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function BuildOffer() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // this goes one step back in history
  };
  const [value, setValue] = React.useState({
    page: "0",
    type: "0",
    group: "0",
    Tags: "0",
  });

  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [isButterflyEnabled, setIsButterflyEnabled] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const location = useLocation();
  const { state } = location;
  const offerType = state?.type || "RESTAURANT";
  console.log(state, "state");

  const [activeTab, setActiveTab] = React.useState(0);
  const [alignment, setAlignment] = useState("activate");

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [legal4, setLegal4] = useState<string>("");
  const groupOptions = [
    { label: "Groups 1", value: "10" },
    { label: "Groups 2", value: "20" },
    { label: "Groups 3", value: "30" },
    { label: "Groups 4", value: "40" },
  ];

  const tagOptions = [
    { label: "Tags 1", value: "10" },
    { label: "Tags 2", value: "20" },
    { label: "Tags 3", value: "30" },
    { label: "Tags 4", value: "40" },
  ];

  const filteredOptions = groupOptions.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleGroupChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectedGroups(typeof value === "string" ? value.split(",") : value);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [searchTagTerm, setSearchTagTerm] = useState("");

  const handleTagsChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectedTags(typeof value === "string" ? value.split(",") : value);
  };

  const handleTagsSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTagTerm(e.target.value.toLowerCase());
  };

  const filteredTagOptions = tagOptions.filter((option) =>
    option.label.toLowerCase().includes(searchTagTerm)
  );

  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              Build Offer
            </h1>
          </div>
          <div className="archv_ryt">
            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleChange}
              aria-label="Platform"
            >
              <ToggleButton value="activate">Activate</ToggleButton>
              <ToggleButton value="archived">Archived</ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>

        <Box
          className="ds_none custom_tabs2 mt_40 mb_30"
          sx={{ width: "100%" }}
        >
          <Tabs
            aria-label="basic tabs example"
            className="custom_tabs_links"
            value={valueTabs}
            onChange={(e, newValue) => setValueTabs(newValue)}
          >
            <Tab {...a11yProps(0)} />
            <Tab {...a11yProps(1)} />
            <Tab {...a11yProps(2)} />
          </Tabs>
        </Box>

        <div className="cards">
          <form>
            <CustomTabPanel value={valueTabs} index={0}>
              <div className="gap_m">
                <div className="control_group w_33">
                  <label>Title</label>
                  <TextField
                    placeholder="Enter Title"
                    hiddenLabel
                    fullWidth
                  ></TextField>
                </div>

                <div className="control_group w_33">
                  <label>Badge</label>
                  <TextField
                    placeholder="Enter Badge"
                    hiddenLabel
                    fullWidth
                  ></TextField>
                </div>

                <div className="control_group w_33">
                  <label>Subtitle</label>
                  <TextField
                    placeholder="Enter Subtitle"
                    hiddenLabel
                    fullWidth
                  ></TextField>
                </div>

                <div className="control_group w_33">
                  <label>Category</label>
                  <Select
                    className="dropse"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    value={value.page}
                    name="page"
                    onChange={handleChange1}
                  >
                    <MenuItem value="0" disabled>
                      Select Category
                    </MenuItem>

                    <MenuItem value="10">Dining</MenuItem>
                    <MenuItem value="20">Events</MenuItem>
                    <MenuItem value="30">Experience</MenuItem>
                    <MenuItem value="40">Beach Clubs</MenuItem>
                    <MenuItem value="50">Benefits</MenuItem>
                    <MenuItem value="60">Wellness</MenuItem>
                  </Select>
                </div>
                <div className="control_group w_66">
                  <label>Type</label>

                  <Select
                    className="dropse"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    name="type"
                    value={value.type}
                    onChange={handleChange1}
                  >
                    <MenuItem value="0" disabled>
                      Select Type
                    </MenuItem>

                    <MenuItem value="10"> Restaurant</MenuItem>
                    <MenuItem value="20">Events</MenuItem>
                    <MenuItem value="30">Contact Dealers</MenuItem>
                    <MenuItem value="40">Others</MenuItem>
                  </Select>
                </div>

                <div className="w_100 control_group">
                  <label>Offer Display Period</label>
                  <div className="gap_m">
                    <div className="w_50 control_group">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="form_control"
                          slots={{
                            openPickerIcon: () => (
                              <img
                                src="/static/images/calendar_icon.svg"
                                alt="icon"
                              />
                            ),
                            textField: (params) => (
                              <TextField
                                {...params}
                                fullWidth
                                placeholder="Start Date"
                                hiddenLabel
                              />
                            ),
                          }}
                          desktopModeMediaQuery="(min-width:0px)"
                        />
                      </LocalizationProvider>
                    </div>

                    <div className="w_50 control_group">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="form_control"
                          slots={{
                            openPickerIcon: () => (
                              <img
                                src="/static/images/calendar_icon.svg"
                                alt="icon"
                              />
                            ),
                            textField: (params) => (
                              <TextField
                                {...params}
                                fullWidth
                                placeholder="End Date"
                                hiddenLabel
                              />
                            ),
                          }}
                          desktopModeMediaQuery="(min-width:0px)"
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>

                <div className="control_group w_100">
                  <div className="gap_m">
                    <div className="control_group w_50 d_flex">
                      <label className="mb_0"> Butterfly Effect</label>
                      <IosSwitchMain
                        checked={isButterflyEnabled}
                        onChange={(e) =>
                          setIsButterflyEnabled(e.target.checked)
                        }
                      />
                    </div>
                  </div>
                </div>
                {isButterflyEnabled && (
                  <div className="w_100 control_group">
                    <label>Butterfly Effect Active Dates</label>
                    <div className="gap_m">
                      <div className="w_50 control_group">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="form_control"
                            slots={{
                              openPickerIcon: () => (
                                <img
                                  src="/static/images/calendar_icon.svg"
                                  alt="icon"
                                />
                              ),
                              textField: (params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  placeholder="Start Date"
                                  hiddenLabel
                                />
                              ),
                            }}
                            desktopModeMediaQuery="(min-width:0px)"
                          />
                        </LocalizationProvider>
                      </div>

                      <div className="w_50 control_group">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="form_control"
                            slots={{
                              openPickerIcon: () => (
                                <img
                                  src="/static/images/calendar_icon.svg"
                                  alt="icon"
                                />
                              ),
                              textField: (params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  placeholder="End Date"
                                  hiddenLabel
                                />
                              ),
                            }}
                            desktopModeMediaQuery="(min-width:0px)"
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  </div>
                )}
                <div className="control_group w_50">
                  <label>Groups</label>
                  <Select
                    multiple
                    displayEmpty
                    className="dropse"
                    value={selectedGroups}
                    onChange={handleGroupChange}
                    input={<InputBase />}
                    renderValue={(selected) => {
                      if (selected.length === 0) return <span>Groups</span>;
                      return groupOptions
                        .filter((opt) => selected.includes(opt.value))
                        .map((opt) => opt.label)
                        .join(", ");
                    }}
                    MenuProps={{
                      PaperProps: { style: { maxHeight: 300, padding: 0 } },
                    }}
                  >
                    <Box px={2} pt={1} pb={1}>
                      <TextField
                        fullWidth
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        variant="standard"
                        autoFocus
                      />
                    </Box>

                    {filteredOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        className="multi_check_select"
                      >
                        <Checkbox
                          checked={selectedGroups.includes(option.value)}
                        />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="control_group w_50">
                  <label>Tags</label>
                  <Select
                    multiple
                    displayEmpty
                    className="dropse"
                    value={selectedTags}
                    onChange={handleTagsChange}
                    input={<InputBase />}
                    renderValue={(selected) => {
                      if (selected.length === 0) return <span>Tags</span>;
                      return tagOptions
                        .filter((opt) => selected.includes(opt.value))
                        .map((opt) => opt.label)
                        .join(", ");
                    }}
                    MenuProps={{
                      PaperProps: { style: { maxHeight: 300, padding: 0 } },
                    }}
                  >
                    <Box px={2} pt={1} pb={1}>
                      <TextField
                        fullWidth
                        placeholder="Search..."
                        value={searchTagTerm}
                        onChange={handleTagsSearchChange}
                        variant="standard"
                        autoFocus
                      />
                    </Box>

                    {filteredTagOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        className="multi_check_select"
                      >
                        <Checkbox
                          checked={selectedTags.includes(option.value)}
                        />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                <div className="control_group w_100">
                  <label>Description</label>
                  <ReactQuill
                    value={legal4}
                    onChange={setLegal4}
                    theme="snow"
                  />
                </div>

                <div className="control_group w_100">
                  <label>Image Upload</label>
                  <div className="gap_m">
                    {Array.from({ length: 3 }).map((_, index) => (
                      <div className="control_group w_33" key={index}>
                        <figure className="upload_image v2 centered">
                          <input type="file" />
                          <figcaption>
                            <AddCircleOutlineIcon />
                            <p>Add Image {index + 1}</p>
                          </figcaption>
                        </figure>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="control_group w_100">
                  <div className="btn_name">
                    <div className="btn_lft w_50">
                      <label>Button Name</label>
                      <TextField
                        placeholder="Enter button name"
                        hiddenLabel
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="btn_flex">
                      <Button
                        className="btn btn_primary"
                        onClick={() => setValueTabs((prev) => prev + 1)}
                      >
                        Next
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs} index={1}>
              {offerType === "EVENT" ? (
                <EventForm alignment={alignment} />
              ) : offerType === "EXPERIENCE" ? (
                <ExperienceForm alignment={alignment} />
              ) : offerType === "OTHERS" ? (
                <OthersForm alignment={alignment} />
              ) : (
                <ResturantForm alignment={alignment} />
              )}
            </CustomTabPanel>

            {/* <CustomTabPanel value={valueTabs} index={2}>
              <ResturantForm />
            </CustomTabPanel> */}
          </form>
        </div>
      </MainContainer>
    </>
  );
}

export default BuildOffer;
